import React from 'react';
import PropTypes from 'prop-types';

import styles from '../LoginButton/LoginButton.module.scss';

const LoginLoadingButton = ({ isMobile }) =>
  isMobile ? (
    <li className={styles.emptyResponseMobile} />
  ) : (
    <div className={styles.emptyResponse} />
  );

LoginLoadingButton.propTypes = {
  isMobile: PropTypes.bool.isRequired
};

export default LoginLoadingButton;
